var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwitter = function SvgTwitter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D9BF0",
    d: "M9.042 21c-2.427 0-4.688-.706-6.592-1.923 1.616.104 4.469-.146 6.243-1.838-2.67-.123-3.873-2.17-4.03-3.045.227.088 1.308.193 1.919-.052-3.07-.77-3.541-3.464-3.436-4.286.575.402 1.552.542 1.936.507-2.86-2.047-1.832-5.126-1.326-5.79 2.053 2.843 5.13 4.44 8.936 4.53a4.4 4.4 0 0 1-.11-.98 4.367 4.367 0 0 1 4.361-4.373c1.259 0 2.393.535 3.189 1.39.84-.197 2.106-.659 2.725-1.058-.312 1.12-1.283 2.054-1.87 2.4.005.012-.005-.012 0 0 .516-.078 1.912-.346 2.463-.72-.273.629-1.302 1.675-2.147 2.26C21.46 14.954 16.157 21 9.042 21"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as Icon };
export default "img/element-icons/brands/twitter.b825e3c.svg";